<template>
  <div>
    <div class="split-box">
      <div class="split-line"></div>
      <div class="split-name">【竞价文件】</div>
    </div>
    <template>
      <!-- {{ appendList }} -->
      <FileDownload :List="appendList" @Delete="Delete" @uploadFile="uploadFile" @saveSuccess="{}" :id="id"
        :fieldtype="11" />
    </template>
  </div>
</template>
<script>
import FileDownload from '../../../components/FileDownload'
export default {
  name: 'changeAppend',
  components: {
    FileDownload
  },
  props: {
    appendList: {
      type: Array,
      default: () => []
    },
    id: Number,
  },
  methods: {
    async Delete(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          let index = this.appendList.findIndex(
            (val) => val.appendfromid === file.appendfromid
          );
          this.appendList.splice(index, 1);
        })
        .catch(() => { });
    },
    async uploadFile(item) {
      this.appendList.push(item)
    }
  }
}

</script>

<style lang='scss' scoped>
</style>
